import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignSelf: 'center',
        marginVertical: 10,
    },
    containerAvatar: { maxWidth: '35%' },
    avatar: {
        aspectRatio: 1,
        width: '100%',
        borderRadius: 10,
    },
    containerIcon: {
        zIndex: 2,
        bottom: -12,
        right: -12,
        alignSelf: 'flex-end',
        borderWidth: 1.0,
        borderColor: 'white',
        backgroundColor: 'white',
        position: 'absolute',
        borderRadius: 30,
        alignItems: 'center',
    },
    icon: {
        zIndex: 2,
        alignSelf: 'center',
        marginLeft: 2,
    },
    dataBlock: {
        flex: 1,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginLeft: 15,
        marginRight: 15,
        marginBottom: 0,
        marginTop: 0,
    },
    editIcon: {
        justifyContent: 'Top',
        marginTop: 0,
    },
    name: {
        fontSize: 19,
        fontWeight: 'bold',
        alignItems: 'flex-start',
        color: theme.colors.textPrimary,
        marginBottom: 0,
    },
    user: {
        fontSize: 15,
        fontWeight: 'regular',
        color: theme.colors.textPrimary,
    },
    version: {
        fontSize: 10,
        fontWeight: 'bold',
        color: theme.colors.mediumGray,
        marginTop: 8,
    },
    containerTextIcon: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 6,
    },
    iconButton: {
        marginHorizontal: 5,
    },
    textButton: {
        fontSize: 14,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
    },
})

export default styles
